/**
 * Formats item count text with proper pluralization and i18n support
 * @param count - Number of items
 * @param includeParentheses - Whether to wrap in parentheses (default: false)
 * @returns Formatted item count string
 */
export const formatItemCount = (
  count: number,
  includeParentheses = false
): string => {
  const text = `${count}`;
  return includeParentheses ? `(${text})` : text;
};
